<layout-default>
    <div header>
        <div toolbar>
            <h4>
                <i-feather name="sliders"></i-feather> {{'List of forbidden words' | translate}}
            </h4>
        </div>

        <div toolbar>
            <button *ngIf="[Permissions.FilterWordEdit] | checkPermissionsPipe" class="btn btn-sm btn-uppercase btn-white"
                [routerLink]="['../create']">
                <i-feather [style.height.px]="23" [style.width.px]="13" class="mg-r-10" name="plus"></i-feather> {{ 'Add new word' | translate }}
            </button>
            <div id="profanity-filter-btn-search" class="filter-container">
                <div class="phrase-filter">
                    <input type='text' class="list-filter form-control" placeholder="{{'type to search' | translate}}" (keyup)='applyFiltering($event)'/>
                </div>
            </div>
        </div>
        <hr />
    </div>
    
    <div content>
        <div *ngIf="(list$ | async) as list">

            <ngx-datatable 
                id="profanity-filter-table" 
                class="bootstrap" 
                [rows]="rows" 
                [columns]="columns" 
                [columnMode]="'flex'"
                [headerHeight]="50" 
                [footerHeight]="50" 
                [messages]="tableMessages" 
                [rowHeight]="'auto'" 
                [externalPaging]="true"
                [count]="list.totalElements"
                [offset]="queryParams.page"
                [rowClass]="rowClass"
                [limit]="queryParams.size"
                [scrollbarH]="scrollBarHorizontal"
                (sort)="onSort($event)"
                (page)="setPage($event)">
                <ng-container *ngFor="let col of columns">
                    <ngx-datatable-column [name]="col.prop" [flexGrow]="col.flexGrow" [prop]="col.prop" [sortable]="col.sortable">
                        <ng-template let-column="column" ngx-datatable-header-template class="header" let-sort="sortFn">
                            <b (click)="sort()">{{ col.name | translate }}</b>
                        </ng-template>
                        <ng-template let-row="row" let-value="value" let-rowIndex="rowIndex" ngx-datatable-cell-template>

                            <div [ngSwitch]="col.prop">
                                <div *ngSwitchCase="'id'">
                                    {{rowIndex + 1 + (queryParams.size * queryParams.page)}}
                                </div>

                                <div *ngSwitchCase="'modifiedAt'">
                                    {{value | date:'d-MM-yyyy HH:mm'}}
                                </div>
    
                                <div *ngSwitchCase="'options'">
                                    <div class="dropdown" dropdown>
                                        <button
                                            class="btn btn-outline-secondary btn-xs dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton">
                                            {{ 'Select' | translate }}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right div-main-actions">
                                            
                                            <a 
                                                id="profanity-filter-btn-show-details"
                                                *ngIf="[Permissions.FilterWordEdit] | checkPermissionsPipe"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                [routerLink]="['../', 'edit', row.id]">
                                                    {{'Edit' | translate }}
                                            </a>
    
                                            <a 
                                                id="profanity-filter-btn-remove"
                                                *ngIf="[Permissions.FilterWordEdit] | checkPermissionsPipe"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                (click)="remove(row.id)">
                                                    {{'Remove' | translate }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div id="profanity-filter-table-col-{{col.id}}" *ngSwitchDefault>{{ value }}</div>
                            </div>

                        </ng-template>
                    </ngx-datatable-column>
                </ng-container>
            </ngx-datatable>
        </div>

        <div *ngIf="loader" class="load-spinner text-center">
            <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i> {{ 'Please, wait!' | translate }}
        </div>
    </div>

</layout-default>

<ng-template #confirmation>
    <div class="modal-header">
        <h4 class="modal-title">{{'Confirm action' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="decline()"><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body text-center">
        <p>{{'Do you confirm the action' | translate }}?</p>
        <button type="button" class="btn btn-brand-01" (click)="confirm()">
            {{'Yes, remove' | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">{{'Cancel' | translate }}</button>
    </div>
</ng-template>